import type { Route } from '@angular/router';
import {
  hasStringPathParamCanActivateGuard,
  sequentialDeactivateGuards,
} from '@pct-ng/core/router';
import { showToasterDeactivateGuard } from '@pct-ng/form';
import { dirtyCheckCanDeactivateGuard } from '@pct-ng/feature-dirty-check';

export const eventCategoryRoutes: Route[] = [
  {
    path: '',
    loadComponent: () =>
      import('./list/event-category-list.component').then(
        ({ EventCategoryListComponent }) => EventCategoryListComponent,
      ),
    pathMatch: 'full',
  },
  {
    path: 'new',
    loadComponent: () =>
      import('./details/event-category-details.component').then(
        ({ EventCategoryDetailsComponent }) => EventCategoryDetailsComponent,
      ),
    title: 'PAGES.EVENT.CATEGORY.BREADCRUMB.NEW',
    canDeactivate: [
      sequentialDeactivateGuards([
        dirtyCheckCanDeactivateGuard(),
        showToasterDeactivateGuard('PAGES.EVENT.CATEGORY.SINGULAR'),
      ]),
    ],
  },
  {
    path: ':id',
    loadComponent: () =>
      import('./details/event-category-details.component').then(
        ({ EventCategoryDetailsComponent }) => EventCategoryDetailsComponent,
      ),
    title: 'PAGES.EVENT.CATEGORY.BREADCRUMB.EDIT',
    canActivate: [hasStringPathParamCanActivateGuard('id')],
    canDeactivate: [
      sequentialDeactivateGuards([
        dirtyCheckCanDeactivateGuard(),
        showToasterDeactivateGuard('PAGES.EVENT.CATEGORY.SINGULAR'),
      ]),
    ],
  },
];
